import axios from 'axios'

const client = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
})

// Attach JWT access token to every request
client.interceptors.request.use((config) => {
  const tokens = localStorage.getItem('tembo_tokens')
  if (tokens) {
    const { access } = JSON.parse(tokens)
    config.headers.Authorization = `Bearer ${access}`
  }
  return config
})

// Attempt token refresh on 401
client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true
      try {
        const tokens = localStorage.getItem('tembo_tokens')
        if (!tokens) throw new Error('No tokens')
        const { refresh } = JSON.parse(tokens)
        const { data } = await axios.post('/api/v1/auth/token/refresh', { data: { refresh_token: refresh } })
        const newAccess = data.result.access_token
        const newRefresh = data.result.refresh_token
        const updated = {
          ...JSON.parse(tokens),
          access: newAccess,
          ...(newRefresh ? { refresh: newRefresh } : {}),
        }
        localStorage.setItem('tembo_tokens', JSON.stringify(updated))
        original.headers.Authorization = `Bearer ${newAccess}`
        return client(original)
      } catch {
        localStorage.removeItem('tembo_tokens')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default client
